import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { AreaChart, Area } from 'recharts';
import { calculateTrend } from './calc-trend';
export var TrendGraphKey = 'trend-graph';
var TrendGraph = /** @class */ (function (_super) {
    __extends(TrendGraph, _super);
    function TrendGraph() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultHeight = 45;
        _this.defaultWidth = 185;
        _this.dataKey = 'y';
        return _this;
    }
    TrendGraph.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames(TrendGraphKey, props.className);
        var width = this.props.width || this.defaultWidth;
        var height = this.props.height || this.defaultHeight;
        var trendData = calculateTrend(props.value);
        return (React.createElement(AreaChart, { className: classNames, width: width, height: height, data: trendData },
            React.createElement(Area, { type: 'monotone', dataKey: this.dataKey, fill: props.color, fillOpacity: 0.1, stroke: props.color, strokeWidth: 2, isAnimationActive: !props.disableAnimation })));
    };
    return TrendGraph;
}(React.PureComponent));
export { TrendGraph };
//# sourceMappingURL=index.js.map